import {$qsAll} from '../../@shared/ts/dom';

/**
 * Initializes homepage UI states and event listeners.
 */
function initHomepageEvents() {
	$qsAll('.dashboard-container .sub-logos-toggle').forEach($button => {
		$button.addEventListener('click', (event: Event) => {
			event.stopImmediatePropagation();
			const $subLogosContainer = $button.closest('.sub-logos');
			const $subLogosToggle = $subLogosContainer?.querySelector('.sub-logos-toggle');
			if ($subLogosContainer?.hasAttribute('expanded')) {
				$subLogosContainer?.removeAttribute('expanded');
				if ($subLogosToggle) {
					$subLogosToggle.innerHTML = 'See more';
				}
			} else {
				$subLogosContainer?.setAttribute('expanded', '');
				if ($subLogosToggle) {
					$subLogosToggle.innerHTML = 'See less';
				}
			}
		});
	});

	unHideElements();
}

function unHideElements() {
	$qsAll('.opacity-zero').forEach(($element: HTMLElement) => {
		$element.classList.remove('opacity-zero');
	});
}

export {initHomepageEvents};
